export default __webpack_public_path__ + "static/media/img3.06bb6130.svg";